import React from "react";
import { Link } from "react-router-dom";
import { FaFilePdf, FaArrowLeft } from "react-icons/fa";
import { useLanguage } from "./LanguageContext";

import "../assets/css/resume.css";
import "../assets/css/font.css";

const PDF_LINKS = {
  pt: "/resume-pt.pdf",
  en: "/resume-en.pdf",
};

function Resume() {
  const { t, lang } = useLanguage();

  return (
    <section className="section resume-page">
      <div className="container resume-inner">
        <Link to={`/${lang}`} className="resume-back mono">
          <FaArrowLeft aria-hidden="true" /> {t.resume.back}
        </Link>
        <span className="eyebrow">{t.resume.title}</span>
        <h1 className="section-heading">{t.resume.subtitle}</h1>
        <p className="resume-description">{t.resume.redirectingText}</p>
        <a
          href={PDF_LINKS[lang]}
          target="_blank"
          rel="noreferrer"
          className="button button-primary resume-button"
        >
          <FaFilePdf aria-hidden="true" />
          {t.resume.resumeLinkText}
        </a>
      </div>
    </section>
  );
}

export default Resume;
